import useTranslator from "../../hooks/useTranslator";

const ContinueAddingPopup = ({
  setShowSkipStepPopup,
  handleSkipStep,
  skipStepLoading,
}) => {
  const { _t } = useTranslator();
  return (
    <div
      className={`popup-overlay fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 wrapper-modal modal-fixed-screen `}
    >
      <div className="popup-content2 cancelAddingGuarantorModal position-relative popup-content bg-white">
        <h2 className="word-break">
          {_t("documentAnalysisIsTakingMoreTimeThenExpected")}
        </h2>
        <p>{_t("doYouWantToSkipThisStep")}</p>
        <div className="cancelButtonWrapper">
          <button
            onClick={() => setShowSkipStepPopup(false)}
            className="addGuarantorButton goBackButton"
          >
            {_t("stayHere")}
          </button>
          <button
            disabled={skipStepLoading}
            onClick={handleSkipStep}
            className="btnNext addGuarantorButton"
          >
            {skipStepLoading ? _t("skippingStep") : _t("skipStep")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ContinueAddingPopup;
